<template>
  <div :id="componentId" class="spm1-gala" :style="{ backgroundColor }">
    <div class="spm1-gala-tabs">
      <div
        v-for="(tab, idx) in tabs"
        :key="idx"
        class="spm1-gala-tab"
        :class="{ active: idx === activeIndex }"
        :style="tabStyle(idx)"
        @click="activeIndex = idx"
      >
        <span class="spm1-gala-tab-text" :style="tabTextStyle(idx)">{{ tab.title }}</span>
      </div>
    </div>
    <div class="spm1-gala-image-wrapper" :style="wrapperStyle">
      <img class="spm1-gala-image" referrerpolicy="no-referrer" :src="tabs[activeIndex].imageUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileReviewGala',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_12'
    }
  },
  data() {
    return {
      activeIndex: 0,
      backgroundColor: 'rgba(43, 131, 120, 1)',
      labelFontColor: 'rgba(102, 102, 102, 1)',
      labelBackgroundColor: 'rgba(243, 246, 243, 1)',
      tabs: [
        {
          title: '2025区域农业品牌年度案例',
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG894172f6449fc8b04155bf0a17efac53.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025区域农业公用品牌价值评价',
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025中国区域农业形象品牌影响力指数',
          imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025中国区域农业产业品牌影响力指数',
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG5adf7b382decbc2b0222481272ddf408.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        }
      ]
    }
  },
  computed: {
    wrapperStyle() {
      const tab = this.tabs[this.activeIndex]
      return {
        backgroundImage: tab && tab.selectedMainBgImage ? `url(${tab.selectedMainBgImage})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
    }
  },
  methods: {
    tabStyle(idx) {
      const tab = this.tabs[idx]
      if (idx === this.activeIndex && tab && tab.selectedLabelBgImage) {
        return {
          backgroundImage: `url(${tab.selectedLabelBgImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
          backgroundColor: 'transparent'
        }
      }
      return { backgroundColor: this.labelBackgroundColor }
    },
    tabTextStyle(idx) {
      const tab = this.tabs[idx]
      if (idx === this.activeIndex && tab && tab.selectedFontColor) {
        return { color: tab.selectedFontColor }
      }
      return { color: this.labelFontColor }
    }
  }
}
</script>

<style scoped>
.spm1-gala {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-gala-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
}

.spm1-gala-tab {
  flex: 1;
  min-width: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px 4px;
  box-sizing: border-box;
}

.spm1-gala-tab-text {
  width: 100%;
  font-size: 11px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  line-height: 14px;
  white-space: normal;
  word-break: break-all;
  overflow-wrap: break-word;
  display: block;
  max-height: 28px;
  overflow: hidden;
}

.spm1-gala-image-wrapper {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.spm1-gala-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>
